const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ObservationsPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneObservations extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		// the location to inject an observation into the DOM, if set
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.AddImageTargetDisplayName = '';
	}

	/**
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	onBeforeRender(pRenderable)
	{
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(false);

		return super.onBeforeRender(pRenderable);
	}

	/**
	 * @param {import('pict-view').ErrorCallback} fCallback - The callback to run after the view is rendered
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object
	 */
	/**
	 * Render one tab's view without letting its failure take the sibling tabs with it.
	 *
	 * These run as a serial chain, so an unguarded throw in the first tab leaves every later tab
	 * unrendered and the pane's open callback unfired.
	 * @param {string} pViewName - The view to render
	 * @return {void}
	 */
	renderTabView(pViewName)
	{
		try
		{
			this.pict.views[pViewName].renderAsync(false, false, false, false, (pError) =>
			{
				if (pError)
				{
					this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
					return;
				}
				this.log.info(`${pViewName} view rendered`);
			});
		}
		catch (pError)
		{
			this.log.error(`Failed to render the ${pViewName} tab: ${pError?.message || pError}`);
		}
	}

	onAfterRenderAsync(fCallback, pRenderable)
	{
		super.onAfterRenderAsync((pError) =>
		{
			// set the callback that runs when the search results are returned
			this.pict.views.ObservationSearch.setObservationSearchResultsCallback((pResults) =>
			{
				// collapse the filter panel
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
				// render the pagination controls
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
				{
					this.log.info('Observation Search results rendered');
				});
			});
			// set the search filters for the observation search view
			this.pict.views.ObservationSearch.setCurrentSearchFilters({
				PageSize: 15,
			});
			// render each tab's view; a failure in one must not strand the others
			this.renderTabView('ObservationSearch');

			// set the instance configuration for the observation create media view, then render it
			try
			{
				this.pict.views.ObservationCreateMedia.setInstanceConfiguration({
					IDProject: this.AppData?.DocumentData?.ReportData?.IDProject || 0,
					IDCustomer: this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser?.CustomerID || 0,
					IDDocument: this.AppData?.DocumentData?.ReportData?.IDDocument || 0,
				});
				this.pict.views.ObservationCreateMedia.render();
			}
			catch (pRenderError)
			{
				this.log.error(`Failed to render the ObservationCreateMedia tab: ${pRenderError?.message || pRenderError}`);
			}
			// render the set view
			this.renderTabView('ObservationSet');

			// the panel opens in this callback, so we need to wait for it to open before we can build the included observations list
			if (fCallback)
			{
				fCallback(pError);
			}
		}, pRenderable);
	}

	/**
	 * This function is used to clear the observation panel target and the banner on the header. The removes the "add mode" flow.
	 * @return {void}
	 */
	clearObservationPanelTarget()
	{
		this.AddImageTargetView = '';
		this.AddImageTargetInput = '';
		this.pict.views.HeadlightPanels.ModePanelLeft = '';
		this.pict.views.HeadlightPanels.ModePanelRight = '';
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', '');
		// hide the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = '';

		this.pict.views.ObservationSearch.setMode('');
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 * @param {string} pBackState - The state to return to when the observation detail view is closed
	 * @return {void}
	 */
	handleObservationImagePreviewClick(event, pIDObservation, pBackState)
	{
		this.showObservationDetailView(event, pIDObservation, pBackState);
	}

	/**
	 * This function is used to handle the selection of an observation detail view or adding an observation to the document.
	 * @param {object} event - The click event
	 * @param {number} pIDObservation - The ID of the observation to add to the document
	 */
	async handleObservationAddToProjectFileClick(event, pIDObservation)
	{
		// if in Add Mode, add the observation to project files
		if (document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') !== 'add-to-folder')
		{
			this.pict.log.error('Observation Panel is not in "add" mode. Cannot add observation to project files.', { pIDObservation });
			return;
		}
		// and attach it to the project file folder
		await this.handleObservationListSelection(event, pIDObservation, 'add-to-folder');
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		// const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		// if (tmpInjectionMethod)
		// {
		// 	await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		// }
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {Promise<boolean>}
	 */
	async addObservationToDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is already included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// we should push the observation record to the document observation list for consistency (not just the ID)
		const tmpObservationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		if (!tmpObservationRecord)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not found in the system.',
				type: 'is-danger',
			});
			return false;
		}
		// add the observation to the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.concat(tmpObservationRecord);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [ tmpObservationRecord ];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been added to the document.',
			type: 'is-success',
		});
		return true;
	}

	/**
	 * This function is used to remove an observation from a document.
	 * @param {number} pIDObservation - The observation id to remove from the document
	 * @return {boolean}
	 */
	removeObservationFromDocument(pIDObservation)
	{
		if (this.AppData.DocumentData.ReportData.Locked)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The document is locked and cannot be modified.',
				type: 'is-danger',
			});
			return false;
		}
		// check if the observation is already included in the document
		const includedObservation = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		if (!includedObservation)
		{
			this.pict.views.HeadlightPanels.toast({
				message: 'The observation is not included in the document.',
				type: 'is-warning',
			});
			return false;
		}
		// remove the observation from the document
		const tmpObservations = this.AppData?.DocumentData?.ReportData?.Observations;
		if (tmpObservations && Array.isArray(tmpObservations))
		{
			this.AppData.DocumentData.ReportData.Observations = tmpObservations.filter((observation) => observation.IDObservation != pIDObservation);
		}
		else
		{
			this.AppData.DocumentData.ReportData.Observations = [];
		}
		// show a success message
		this.pict.views.HeadlightPanels.toast({
			message: 'The observation has been removed from the document.',
			type: 'is-success',
		});
		return true;
	}

	closeHandler()
	{
		// Clear any Add/QuickCapture buttons in ObservationCardDeck inputs that were left in an
		// `is-loading` state by an add flow the user has now dismissed (X, escape, background click,
		// or toggling a different panel). Without this, the button stays stuck because the flow's
		// onAfterCallback (which normally removes the class) only fires when the add completes.
		this.pict.providers?.ObservationCardDeckProvider?.clearPendingAddButtonLoadingState?.();
		this.pict.views.ObservationSearch.setMode('add-to-document');
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = undefined;
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterCallback = undefined;
	}

	/**
	 * This function is used to handle the addition of an observation to a document.
	 * @param {Event} event - The click event
	 * @param {object} pIDObservation - The observation id to add to the document
	 * @param {string} pAction - The action to take (add or remove)
	 * @param {boolean} [pClosePanel=false] - Whether to close the panel after the action is completed
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationListSelection(event, pIDObservation, pAction, pClosePanel = false)
	{
		// prevent the panels from closing
		if (event)
		{
			event.stopPropagation();
			event.preventDefault();
		}
		let observationRecord = this.pict.views.ObservationSearch.CurrentSearchResults?.find((/** @type {{ IDObservation: any; }} */ observation) => observation.IDObservation == pIDObservation);
		if (!observationRecord)
		{
			this.log.warn('Failed to find observation record from search results. Doing a look up for this record...', { pIDObservation });
			// if the observation is not found in the search results, try to get it from the provider
			observationRecord = await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation);
		}
		// check if the observation is already included in the document
		switch (pAction)
		{
		case 'add-to-document':
			await this.addObservationToDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'add-to-folder':
		case 'add-to-root':
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationRecord);
			break;
		case 'add-to-set':
			// join to the document record
			if (this.AppData?.DocumentData?.ReportData?.IDDocument)
			{
				// if record is not already in the document, add it
				const tmpObservations = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(observationRecord.IDObservation);
				if (!tmpObservations)
				{
					this.AppData.DocumentData.ReportData.Observations.push(observationRecord);
				}
				// add the observation to the active observation set entity (not just the document)
				if (this.pict.views.ObservationSet?.ActiveObservationSet)
				{
					await this.pict.views.ObservationSet.addObservationToSet(observationRecord.IDObservation);
					this.pict.views.HeadlightPanels.toast({
						message: `Observation added to ${this.pict.views.ObservationSet.ActiveObservationSet.Name || 'Observation Set'}.`,
						type: 'is-success',
					});
				}
				else
				{
					this.pict.views.HeadlightPanels.toast({
						message: 'The observation has been added to the document.',
						type: 'is-success',
					});
				}
				// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the added observation
				if (this.pict.providers.ObservationCardDeckProvider)
				{
					await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'add', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Sets');
				}
			}
			break;
		case 'remove-from-set':
			// nothing to do here
			break;
		case 'remove-from-document':
			this.removeObservationFromDocument(observationRecord.IDObservation);
			// if the ObservationCardDeckProvider is available, refresh any card decks to reflect the removed observation
			if (this.pict.providers.ObservationCardDeckProvider)
			{
				await this.pict.providers.ObservationCardDeckProvider.refreshCardDecks(pIDObservation, 'remove', this.AppData.DocumentData.ReportData.Observations, 'Panels-Observations-Included');
			}
			break;
		case 'remove-from-folder':
			this.pict.views.ProjectFileSearch.removeObservationFromProjectFolderRecord(observationRecord);
			break;
		default:
			this.log.warn('Invalid action for observation selection', { pAction });
			break;
		}
		// save the document now that the observation list is in order. handleSaveAsync resolves WITH the save
		// error (it does not reject), so inspect the returned value — a try/catch here would never fire.
		const tmpSaveError = await this.pict.providers.DocumentProvider.handleSaveAsync();
		if (tmpSaveError)
		{
			this.pict.log.error('Failed to save document!', tmpSaveError);
			this.pict.views.HeadlightPanels.toast({
				message: 'Failed to save document!',
				type: 'is-danger',
			});
		}
		// rebuild the included observations list now that the document is saved
		this.pict.views.ObservationIncluded.buildIncludedObservationsList(true);

		// don't clear/close by default - the user may want to add more observations
		if (pClosePanel)
		{
			// finally, close the observation panel and clear the target
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'close');
			// clear the observation panel target and the banner on the header
			this.pict.views.HeadlightPaneObservations.clearObservationPanelTarget();
		}
		// finally, removing any loading state from the buttons
		this.pict.providers.UtilityProvider.removeAllLoadingClasses();

		// gross
		this.hackyBridgeStuffToSeparateOutLater();
		// also gross
		this.handleMediaUploadCallbacks(event, pIDObservation, pAction);
	}

	// TODO: Relocate this asafp
	hackyBridgeStuffToSeparateOutLater()
	{
		// TODO: This logic should be abstracted away from here so that the panels don't need to know about the ElementConditions view.
		if (this.pict.views?.ElementConditions?.findAllOrphanObservations)
		{
			this.pict.views.ElementConditions.findAllOrphanObservations();
		}
	}

	// TODO: Relocate this asafp
	async handleMediaUploadCallbacks(event, pIDObservation, pAction)
	{
		// then, re-render the view target
		//FIXME: this is "sharing" the callback with another view, seems like a bad idea
		const tmpInjectionMethod = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onAfterCallback;
		if (tmpInjectionMethod)
		{
			await tmpInjectionMethod([ { IDObservation: pIDObservation } ], event);
		}
		// adding to the grossness
		const tmpFallbackCallback = this.pict.views?.ObservationCreateMedia?.InstanceConfiguration?.onFallbackCallback;
		if (pAction === 'add-to-document' && tmpFallbackCallback)
		{
			await tmpFallbackCallback([ { IDObservation: pIDObservation } ], event);
		}
	}

	/**
	 * This function is used to set the observation panel target and the banner on the header. This sets the "add mode" flow.
	 * @param {string} pViewHash - The hash of the view that the observation is being added to
	 * @param {string} pInputHash - The hash of the input that the observation is being added to
	 * @param {string} pInputName - The name of the input that the observation is being added to
	 * @param {string} [pMode] - The mode to set the observation panel to (add, remove, etc.)
	 * @return {void}
	 */
	setObservationPanelTarget(pViewHash, pInputHash, pInputName, pMode)
	{
		const tmpMode = pMode || 'add-to-set';
		this.AddImageTargetView = pViewHash;
		this.AddImageTargetInput = pInputHash;
		this.AddImageTargetDisplayName = pInputName;
		// set the "add to content" mode on the panel to show the "add" buttons
		document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', `${tmpMode}`);
		// set the panel modes to "add" so that the panel is open
		// TODO: we can handle left vs right later as we evolve, but for now, just set both to "add"
		this.pict.views.HeadlightPanels.ModePanelLeft = `${tmpMode}`;
		this.pict.views.HeadlightPanels.ModePanelRight = `${tmpMode}`;
		// set the banner on the header that you are adding an observation
		document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = pInputName;
		this.pict.views.ObservationSearch.setMode(pMode);
	}

	/**
	 * Open the observation detail view for the selected observation to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDObservation - The ID of the observation to view
	 * @param {string} pBackTo - The view to return to when the observation detail view is closed
	 * @param {function} [pCallback] - The callback to run after the observation detail view is rendered
	 * @return {Promise<void>}
	 * @async
	 */
	async showObservationDetailView(event, pIDObservation, pBackTo, pCallback)
	{
		// set the view to return to when the observation detail view is closed
		this.pict.views.ObservationDetails.ObservationDetailsBackTo = pBackTo;
		if (pBackTo && document.getElementById('HeadlightPanels-ObservationPanel').getAttribute('data-panel-mode') === 'add-to-set')
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = true;
		}
		else
		{
			this.pict.views.ObservationDetails.ObservationDetailsBackToSet = false;
		}

		if (event)
		{
			event.currentTarget.classList.add('is-active');
		}
		await this.pict.providers.ObservationProvider.getObservationByID(pIDObservation).then((pResult) =>
		{
			this.pict.views.ObservationDetails.ActiveObservationDetails = pResult;
		});
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationDetails', 'open');
		// render the observation detail view
		this.pict.views.ObservationDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Observation Details View Rendered with Active Record', this.pict.views.ObservationDetails.ActiveObservationDetails);
			if (pCallback)
			{
				pCallback();
			}
		});
	}
}

module.exports = HeadlightPaneObservations;
// additional view-specific templates
const viewSpecificTemplates = [];
// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;
